import { useMemo } from "react"

import { useTranslation } from "react-i18next"

import { useSkipassStore } from "@/store/skipassStore"
import { formatCurrency } from "@/utils/priceUtils"

const useProductTotals = () => {
  const { t } = useTranslation()
  const selectedProducts = useSkipassStore((state) => state.selectedProducts)

  const totals = useMemo(() => {
    const quantity = selectedProducts.reduce((sum, p) => sum + p.quantity, 0)
    const price = selectedProducts.reduce(
      (sum, p) => sum + p.price * p.quantity,
      0
    )

    const firstProduct = selectedProducts[0]

    let priceSuffix = ""

    if (firstProduct) {
      priceSuffix = firstProduct.priceSuffix ?? ""
      if (firstProduct.isSubscriptionProduct) {
        priceSuffix += t("subscriptionPriceSuffix")
      }
    }

    return {
      quantity,
      price,
      priceText: formatCurrency(price, priceSuffix),
    }
  }, [selectedProducts, t])

  const getProductQuantity = (productPriceId: string) => {
    return (
      selectedProducts.find((p) => p.productPriceId === productPriceId)
        ?.quantity || 0
    )
  }

  return {
    selectedProducts,
    getProductQuantity,
    totalQuantity: totals.quantity,
    totalPrice: totals.price,
    totalPriceText: totals.priceText,
  }
}

export default useProductTotals
